<template>
  <!-- input填写框 -->
  <div :class="['magin', bAntmain ? 'onmagin' : 'nomagin']" v-if="bShowIput">
    <div class="tips"></div>
    <div class="input_text">
      <div class="cha" @click="getCha()"></div>
      <textarea
        placeholder="请输入文本"
        :value="sText"
        @input="getDesc"
      ></textarea>
      <div class="btn" @click="sumbit()">确认</div>
    </div>
  </div>
</template>
<script>
import detail from "@/js/detail.js";
export default {
  props: {
    bShowIput: {
      type: Boolean,
      default: false,
    },
    sText: {
      type: String,
      default: false,
    },
    nType: {
      type: Number,
      default: false,
    },
    nIndex: {
      type: Number,
      default: false,
    },
    tagId: {
      default: false,
    },
    category:{
      type:Number,
      default:false
    }
  },
  data() {
    return {
      bAntmain: true, //控制动画播放
      reportId: "", //报告id
      eaitDeas: "", //需要修改的文本
    };
  },
  created() {
    let that = this;
    that.reportId = that.$route.query.reportId;
  },
  //
  methods: {
    //点击弹窗消失
    getCha() {
      this.bAntmain = false;
      setTimeout(() => {
        this.bAntmain = true;
        this.$emit("update:bShowIput", false);
      }, 500);
    },
    //获取文本
    getDesc(e) {
      this.eaitDeas = e.target.value.replace(/\n|\r\n/g, "<br/>");
      //  console.log(e.target.value);
    },
    sumbit() {
      let that = this;
      if (that.nType != 0&&that.nType >0) {
        let deacData = {
          report_id: that.reportId,
          type: that.nType,
          desc: that.eaitDeas,
          tag_id: that.tagId,
        };
        detail.getDesc(deacData).then((res) => {
          //  console.log("修改成功", res);
          // nMark为true为修改其他需求
          let oEait = {
            nIndex: that.nIndex,
            eaitDeas: that.eaitDeas,
            nMark: false,
            tag_id: that.tagId,
            category:that.category,
          };
          this.bAntmain = false;
          setTimeout(() => {
            this.bAntmain = true;
            this.$emit("update:bShowIput", false);
          }, 500);
          this.$emit("sumbit", oEait);
        });
      } else if (that.nType == 0) {
        let markData = {
          report_id: that.reportId,
          mark: that.eaitDeas,
        };
        detail.getReportmark(markData).then((res) => {
          //  console.log(res);
          // nMark为true为修改其他需求
          let oEait = {
            nIndex: that.nIndex,
            eaitDeas: that.eaitDeas,
            nType: that.nType,
            nMark: true,
          };
          this.bAntmain = false;
          setTimeout(() => {
            this.bAntmain = true;
            this.$emit("update:bShowIput", false);
          }, 500);
          this.$emit("sumbit", oEait);
        });
      }else if(that.nType == -1){
        let markData = {
          report_id: that.reportId,
          markextra: that.eaitDeas,
        };
        detail.getMarkextra(markData).then((res) => {
          // nMark为true为修改其他需求
          let oEait = {
            nIndex: that.nIndex,
            eaitDeas: that.eaitDeas,
            nType: that.nType,
            nMark: true,
          };
          this.bAntmain = false;
          setTimeout(() => {
            this.bAntmain = true;
            this.$emit("update:bShowIput", false);
          }, 500);
          this.$emit("sumbit", oEait);
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.onmagin {
  animation: antinpyt 0.5s forwards;
  // transition: all 0.3s;
}
.nomagin {
  animation: noantinpyt 0.5s forwards;
}
.magin {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 99999;

  .tips {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background: #000;
    opacity: 0.6;
  }

  .input_text {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 652px;
    height: 588px;
    background-color: #ffffff;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
    .cha {
      position: absolute;
      background: url(~@/assets/images/antV2/scheme/cha_icon.png) no-repeat
        center/100% 100%;
      width: 42px;
      height: 42px;
      top: -15px;
      right: -15px;
    }
    textarea {
      width: 612px;
      height: 340px;
      background-color: #ffffff;
      padding: 18px;
      box-sizing: border-box;
      border-radius: 20px;
      border: solid 2px #e9f1fd;
      outline: none;
      line-height: 45px;
      -webkit-appearance: none;
      font-size: 28px;
      resize: none;
      margin: 50px auto 0;
    }
    .btn {
      width: 180px;
      height: 80px;
      background-color: #023f88;
      border-radius: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 30px;
      margin-top: 60px;
    }
  }
}
@keyframes antinpyt {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes noantinpyt {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
